export class BtnFilterItemModel {
  id: number;
  color: string;
  title: string;

  parameterToDisplay?: string;
  txtColor?: string;
  brdColor?: string;
  translated?: string;
  count?: number;
}
